﻿import common = require('../../../common');
import HotEditableHiddenFieldComponent = require('./HotEditableHiddenFieldComponent');

class HotEditableHelpers {

    static validateFieldSettings(field: common.IHotEditableFieldComponent) {
        if (!field)
            throw "L'argument 'field' est obligatoire.";

        if (!field.elementName)
            throw "La propriété 'elementName' ('initName') est obligatoire.";
    }

    static convertToVueSelectOptions(input: common.ISelectOption[], selectFirstIfNotSelectedOption?: boolean) {
        input = input || [];
        selectFirstIfNotSelectedOption = selectFirstIfNotSelectedOption === true;//Default is FALSE

        const output = {
            selectedValue: null as common.IHotEditableSelectOption,
            options: [] as common.IHotEditableSelectOption[]
        };

        for (let i = 0; i < input.length; i++) {
            const x = input[i];
            const o = this.convertToVueSelectOption(x);
            if (output.selectedValue === null && x && x.isSelected === true)
                output.selectedValue = o;
            output.options.push(o);
        }

        if (selectFirstIfNotSelectedOption && !output.selectedValue && output.options.length)
            output.selectedValue = output.options[0];

        return output;
    }

    static convertToVueSelectOption(input: common.ISelectOption) {
        if (!input)
            return null as common.IHotEditableSelectOption;

        return {
            label: input.name,
            code: input.value
        } as common.IHotEditableSelectOption;
    }

    static manageHiddenFieldCsv(hiddenField: HotEditableHiddenFieldComponent, value: string, append?: boolean) {
        if (!hiddenField) throw "L'argument 'f' est NULL.";
        if (!value) throw "L'argument 'value' est NULL.";
        append = append === true;//default=FALSE
        var newValue = hiddenField.getTextualValue().replace(value + ',', '').replace(',' + value, '').replace(value, '');//delete existing value
        if (append) {
            if (newValue.length)
                newValue += ',';
            newValue += value;
        }
        hiddenField.setFromTextualValue(newValue);
        return this;
    }
}

export = HotEditableHelpers;